import { render } from "./AIReviewDraft.vue?vue&type=template&id=62838b60&scoped=true&ts=true"
import script from "./AIReviewDraft.vue?vue&type=script&lang=ts"
export * from "./AIReviewDraft.vue?vue&type=script&lang=ts"

import "./AIReviewDraft.vue?vue&type=style&index=0&id=62838b60&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62838b60"]])

export default __exports__